const { getNpcDialogue, activeNpcs} = require('../../common/utils/npc');

function hasDialogueType(caseConf, type) {
  if (!caseConf.dialogue) return false;
  if (type) return caseConf.dialogue[type] && caseConf.dialogue[type].length > 0;
  return false;
}

exports.areQuestionsRecommended = function(caseConf) {
  return hasDialogueType(caseConf, 'questions');
}

exports.areCommandsRecommended = function(caseConf) {
  return hasDialogueType(caseConf, 'commands');
}

exports.areUnsolicitedRecommended = function(caseConf) {
  return hasDialogueType(caseConf, 'unsolicited');
}

exports.areCallsRecommended = function(caseConf) {
  return hasDialogueType(caseConf, 'calls');
}

exports.isAiEnabled = function(caseConf) {
  return caseConf.dialogue && caseConf.dialogue.aiEnabled;
}

exports.isAiDisabled = function(caseConf) {
  return !exports.isAiEnabled(caseConf)
}

exports.areAiQuestionsRecommended = function(caseConf) {
  return exports.isAiEnabled(caseConf) && (hasDialogueType(caseConf, 'aiQuestions') || hasNpcDialogueType(caseConf, 'aiQuestions'));
}

exports.areAiUnsolicitedRecommended = function(caseConf) {
  return exports.isAiEnabled(caseConf) && (hasDialogueType(caseConf, 'aiUnsolicited') || hasNpcDialogueType(caseConf, 'aiUnsolicited'));
}

exports.areAiQuestionsStatementsRecommended = function(caseConf) {
  return exports.areAiQuestionsRecommended(caseConf) || exports.areAiUnsolicitedRecommended(caseConf);
}

exports.areAiEffectsRecommended = function(caseConf) {
  return exports.isAiEnabled(caseConf) && hasDialogueType(caseConf, 'aiEffects');
}

function hasNpcDialogueType(caseConf, type) {
  const npcDialogue = getNpcDialogue(caseConf);
  if (!npcDialogue) return false;
  if (type) return npcDialogue[type] && npcDialogue[type].length > 0;
  return false;
}

exports.isNpcDialogueRecommended = function(caseConf) {
  if (caseConf.dialogue && caseConf.dialogue.aiEnabled) {
    return hasNpcDialogueType(caseConf, 'aiQuestions') || hasNpcDialogueType(caseConf, 'aiUnsolicited');
  } else {
    return hasNpcDialogueType(caseConf, 'questions') || hasNpcDialogueType(caseConf, 'commands') || hasNpcDialogueType(caseConf, 'unsolicited');
  }
}

exports.isNpcQuestionRecommended = function(caseConf) {
  return hasNpcDialogueType(caseConf, 'questions');
}

exports.isNpcCommandRecommended = function(caseConf) {
  return hasNpcDialogueType(caseConf, 'commands');
}

exports.isNpcUnsolicitedRecommended = function(caseConf) {
  return hasNpcDialogueType(caseConf, 'unsolicited');
}

exports.areCustomStatesRecommended = function(caseConf) {
  return caseConf.caseLogicDescription &&
    caseConf.caseLogicDescription.customStates &&
    caseConf.caseLogicDescription.customStates.length;
}

exports.areCustomEnumStatesRecommended = function(caseConf) {
  return caseConf.caseLogicDescription &&
    caseConf.caseLogicDescription.customEnumStates &&
    caseConf.caseLogicDescription.customEnumStates.length;
}

exports.areNpcsActive = function(caseConf) {
  const active = activeNpcs(caseConf);
  return active && active.length > 0;
}
